import React from 'react'
import { Link } from 'react-router-dom';
import { useState } from 'react';
// import FeatherIcon from "feather-icons-react";
import { pagination, Table } from "antd";
import { onShowSizeChange, itemRender } from "../../Pagination"
import Sidebar from '../sidebar/SideBar';
import Footer from '../../footer/Footer';
import { AiOutlineEye } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import { BiPlus } from 'react-icons/bi';
import {candidate} from '../../../utlis/data'
import Header from '../../header/Header';


const UserList = () => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
const secondaryColor="#278D27"
const textColor = '#FFFFFF'
    const onSelectChange = (newSelectedRowKeys) => {
        console.log("selectedRowKeys changed: ", selectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    

    const column = [
        {
            title: "ID",
            dataIndex: "_id",
            sorter: (a, b) => a._id.length - b._id.length,
            // render: (text, record) => (
            //     <>

            //         <Link to="/viewinvoice">{record.DepartmentID}</Link>

            //     </>
            // )
        },
        {
            title: "Name",
            dataIndex: "name",
            sorter: (a, b) => a.name.length - b.name.length
        },
        {
            title: "Location",
            dataIndex: "constituency",
            sorter: (a, b) => a.constituency.length - b.constituency.length
        },
        {
            title: "Phone",
            dataIndex: "phone",
            sorter: (a, b) => a.StartedYear.length - b.StartedYear.length
        },
        // {
        //     title: "No of cards",
        //     dataIndex: "cardLimit",
        //     sorter: (a, b) => a.NoofStudents.length - b.NoofStudents.length
        // },
        {
            title: "Action",
            dataIndex: "Action",
            render: (text, record) => (
                <>
                    <div className="actions">
                        <Link to="#" className="btn btn-sm bg-success-light me-2">
                            <i className="feather-eye">
                                {/* <FeatherIcon icon="eye" /> */}
                                <AiOutlineEye  color='#F97D09' />
                            </i>
                        </Link>
                        <Link to="/editdepartment" className="btn btn-sm bg-danger-light">
                            <i className="feather-edit ">
                                {/* <FeatherIcon icon="edit" className="list-edit"/> */}
                                <FiEdit color='#F97D09' />
                            </i>
                        </Link>
                    </div>
    
    
                </>
            )
        },

    ]
    return (
        <>
            <div className="main-wrapper">
                {/* Header */}
                <Header />

                {/* Sidebar */}
                <Sidebar secondaryColor={secondaryColor} textColor={textColor} />

                {/* Page Wrapper */}

                <div className="page-wrapper">
                    <div className="content container-fluid">
                        {/* Page Header */}
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">User</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active">User</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* /Page Header */}
                        <div className="student-group-form">
                            <div className="row">
                                <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by ID ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by Name ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by location ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="search-student-btn">
                                        <button type="btn" className="btn btn-primary">
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-table">
                                    <div className="card-body">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <h3 className="page-title">User</h3>
                                                </div>
                                                <div className="col-auto text-end float-end ms-auto download-grp">
                                                    {/* <Link to="#" className="btn btn-outline-primary me-2">
                                                        <i className="fas fa-download" /> Download
                                                    </Link> */}
                                                    <Link to="/add-admin" className="btn btn-primary">
                                                        <i className="fas fa-plus" />
                                                        <BiPlus size={24}/>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                        <Table class="table table-stripped table-hover datatable"
                                            pagination={{
                                                total: candidate.length,
                                                showTotal: (total, range) =>
                                                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                                showSizeChanger: true,
                                                onShowSizeChange: onShowSizeChange,
                                                itemRender: itemRender,
                                            }}
                                      
                                            columns={column}
                                            dataSource={candidate}

                                            rowSelection={rowSelection}
                                            rowKey={(record) => record.id}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Footer */}
                    <Footer />
                </div>

            </div>
            {/* /Main Wrapper */}

        </>
    )
}

export default UserList
